import React from 'react';

import i18n from 'i18';

// @mui
import { Box, TextField, Typography } from '@mui/material';

export default class DialogNumberField extends React.Component {
    render() {
        // field, value, onChange

        const translatedLabel = i18n.t(`columns.${this.props.field.label}`);
        const placeholderLabel = i18n.t(
            `placeholder.${this.props.field.label}`
        );
        const required = this.props.field.required;
        const requiredLabel = required ? ' *' : '';
        return (
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2">{translatedLabel + requiredLabel}</Typography>
                <TextField
                    placeholder={placeholderLabel}
                    autoFocus
                    margin="dense"
                    id={this.props.field.id}
                    type="number"
                    value={this.props.value || ''}
                    fullWidth
                    onChange={(event) =>
                        this.props.onChange(event.target.id, event.target.value)
                    }
                />
            </Box>
        );
    }
}
